import { forwardRef, type Ref, type SVGProps } from "react";
const IconMailFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 6H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-.3 3.62-7.44 6.86 6.44 5.9a.9.9 0 0 1 0 1.34 1.1 1.1 0 0 1-1.46 0l-6.45-5.89-2.06 1.89a1.1 1.1 0 0 1-1.46 0l-2.06-1.89-6.45 5.89a1.1 1.1 0 0 1-1.46 0 .9.9 0 0 1 0-1.34l6.44-5.9L4.3 9.62a.9.9 0 0 1 0-1.34 1.1 1.1 0 0 1 1.46 0L16 17.7l10.24-9.42a1.1 1.1 0 0 1 1.46 0 .9.9 0 0 1 0 1.34"
    />
  </svg>
);
const ForwardRef = forwardRef(IconMailFilledSVG);
ForwardRef.displayName = "IconMailFilled";
export { ForwardRef as IconMailFilled };
